(function ($) {
  var w = window,
      windowW = 0,
      $window = $(w),
      $document = $(document),
      $html = $('html'),
      $main = $('#main'),
      $adminBar,
      adminBarVisibleHeight,
      scrollT,
      scrollUp = false,
      $triggerMobile = $('#menuTrigger'),
      sauvScroll = 0;

  //Load js async
  function async(script, callback) {
    var s = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
    s.type = "text/javascript";
    s.async = true;
    s.defer = true;
    s.src = script;
    if (typeof callback == 'function') { s.addEventListener('load', function (e) { callback.call(); }, false); }
    head.appendChild(s);
  }

  //Load css
  function loadCSS(href, callback, media) {
    var doc = w.document;
    var ss = doc.createElement( "link" );
    var ref;
    var refs = ( doc.body || doc.getElementsByTagName( "head" )[ 0 ] ).childNodes;
    ref = refs[ refs.length - 1];
    var sheets = doc.styleSheets;
    ss.rel = "stylesheet";
    ss.href = href;
    ss.media = "only x";
    ref.parentNode.insertBefore( ss, ref.nextSibling );
    var onloadcssdefined = function( cb ){
      var resolvedHref = ss.href;
      var i = sheets.length;
      while( i-- ){
        if( sheets[ i ].href === resolvedHref ){
          return cb();
        }
      }
      setTimeout(function() {
        onloadcssdefined( cb );
      });
    };
    function loadCB(){
      if( ss.addEventListener ){
        ss.removeEventListener( "load", loadCB );
      }
      ss.media = media || "all";
      if ( typeof callback == 'function' ) {
        callback();
      }
    }
    if( ss.addEventListener ){
      ss.addEventListener( "load", loadCB);
    }
    ss.onloadcssdefined = onloadcssdefined;
    onloadcssdefined( loadCB );
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Dimensions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_dimensions() {
    windowW = $window.width();
  }
  update_dimensions();

  function update_scroll() {
    // pas de changement du sens du scroll si on a scrollé de moins de 10px
    scrollUp = Math.abs( $window.scrollTop() - scrollT ) < 10 ? scrollUp : $window.scrollTop() <= scrollT;
    scrollT  = $window.scrollTop();
    $adminBar = $adminBar && $adminBar.length > 0 ? $adminBar : $('#wpadminbar');
    if ( $adminBar && $adminBar.length > 0 ) {
      adminBarVisibleHeight = Math.max( $adminBar.outerHeight() - scrollT + $adminBar.offset().top, 0 ) + 'px';
      document.documentElement.style.setProperty('--adminBarVisibleHeight',adminBarVisibleHeight);
    } else {
      document.documentElement.style.setProperty('--adminBarVisibleHeight',null);
    }
  }
  update_scroll();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu qui se masque
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function auto_hide_header() {
    if(!$html.hasClass('has-menuMobileOpen') && !scrollUp && scrollT > 10) {
      $html.addClass('is-nav-hide');
    } else {
      $html.removeClass('is-nav-hide');
    }
  }
  auto_hide_header();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var idMenuMobileTimeOut = false;
  $triggerMobile.on('click',function(e){
    e.preventDefault();
    menu_mobile_toggle();
  });

  function menu_mobile_toggle() {
    if($html.hasClass('has-menuMobileOpen')) {
      menu_mobile_close();
    } else {
      menu_mobile_open();
    }
  }
  
  function menu_mobile_open() {
    if(!$html.hasClass('is-scrollBlockedMobile')) {
      sauvScroll = scrollT;
      w.scrollTo(0, 0);
      idMenuMobileTimeOut = w.setTimeout(function() {
        $html.addClass('is-scrollBlockedMobile');
      }, 300);
    }
    $html.addClass('has-menuMobileOpen');
  }
  
  function menu_mobile_close() {
    if(idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
    $html.removeClass('is-scrollBlockedMobile');
    // closeSubMenu();
    w.scrollTo(0, sauvScroll);
    w.setTimeout(function() {
      $html.removeClass('has-menuMobileOpen');
    }, 50);
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Grille de produits
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $prods_list  = $main.find( '.prods-list' ),
      $prods_items = $prods_list.find( '.prods-item' );

  function update_prods() {
    if ( windowW <= 425 ) {
      var items_by_line = 2;
    } else if ( windowW <= 620 ) {
      var items_by_line = 3;
    } else if ( windowW <= 768 ) {
      var items_by_line = 4;
    } else {
      var items_by_line = 5;
    }
    $prods_items.each(function(i){
      $(this).attr('style','--row:'+Math.floor( i / items_by_line ));
    });
  }
  update_prods();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Plyr
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var plyr_is_ready = false;
  var plyr_js_is_ready = false;
  var plyr_css_is_ready = false;
  var plyr_js_is_loading = false;
  var plyr_css_is_loading = false;
  var $videosIframes = [];
  $main.find('.media.is-type-video iframe[src]').wrap( '<div class="js-plyr"></div>');

  function init_videos() {
    if( !$videosIframes.length ) return;
    video_load_plyr();
  }

  function reinit_videos() {
    $videosIframes = $main.find('.js-plyr');
    init_videos();
  }
  reinit_videos();

  function video_load_plyr() {
    if(plyr_is_ready) {
      init_plyr_on_video();
      return;
    }

    if(!plyr_js_is_loading) {
      plyr_js_is_loading = true;
      async(url.theme+'lib/plyr.min.js', plyr_js_loaded);
    }
    if(!plyr_css_is_loading) {
      plyr_css_is_loading = true;
      loadCSS(url.theme+'lib/plyr.min.css', plyr_css_loaded);
    }
  }

  function plyr_js_loaded() {
    plyr_js_is_ready = true;
    check_plyr_is_ready();
  }

  function plyr_css_loaded() {
    plyr_css_is_ready = true;
    check_plyr_is_ready();
  }

  function check_plyr_is_ready() {
    if(!plyr_is_ready && plyr_js_is_ready && plyr_css_is_ready) {
      plyr_is_ready = true;
      init_plyr_on_video();
    }
    return plyr_is_ready;
  }

  function init_plyr_on_video() {
    // https://github.com/sampotts/plyr
    var players = Plyr.setup('#main .js-plyr', {
      vimeo: {
        controls: false,
      },
      fullscreen: { enabled: true, fallback: true, iosNative: true, container: null },
      controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen', 'play-large']
    });
  }

  d.addEventListener('lazybeforeunveil', function(e) {
    var $el = $(e.target);
    if(!$el.is('iframe')) return;
    $el.attr('src', $el.attr('data-src'));
    if($el.closest('.media.is-type-video').length) {
      $el.wrap( '<div class="js-plyr"></div>');
    }
    reinit_videos();
    e.preventDefault();
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window.on('scroll', function() {
    update_scroll();
    auto_hide_header();
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window.on('resize', function() {
    update_dimensions();
    update_prods();
    $window.trigger('scroll');
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On load
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $document.on('load', function() {
    $window.trigger('scroll');
  });

})(jQuery);